import React, { Component } from "react";
import Zmage from "react-zmage";
import Fade from "react-reveal";

let id = 0;
class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const projects = this.props.data.projects.map(function (projects) {
      let projectImage = "images/portfolio/" + projects.image;

      return (
        <div key={id++} className="columns portfolio-item">
          <div className="item-wrap">
            <Zmage alt={projects.title} src={projectImage} />
            <a title={projects.url} href={projects.url} target="_blank" rel="noreferrer">
              <div style={{ textAlign: "center" }}>{projects.title}</div>
              <div style={{textAlign: "center", color: "#95A3A3", fontWeight: "bold"}}>{projects.description}</div>
              <div className="columns download" style={{marginTop: "10px"}}>
                  <p>
                    <a href={projects.url} target="_blank" rel="noreferrer" className="button">
                      <i className="fa fa-link" style={{marginRight: "10px"}}></i>Source Code
                    </a>
                  </p>
                </div>
                <div className="columns download" style={{marginTop: "10px"}}>
                  <p>
                    <a href={projects.demo} target="_blank" rel="noreferrer" className="button">
                      <i className="fa fa-link" style={{marginRight: "10px"}}></i>Live Demo
                    </a>
                  </p>
                </div>
            </a>
          </div>
        </div>
      );
    });

    return (
      <section id="portfolio">
        <Fade left duration={1000} distance="40px">
          <div className="row">
            <div className="twelve columns collapsed">
              <h1>PROJECTS</h1>

              <div
                id="portfolio-wrapper"
                className="bgrid-quarters s-bgrid-thirds cf"
              >
                {projects}
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default Portfolio;
